import { defineComponent as _defineComponent } from 'vue'
import { AnimatedListingWithSubViewState } from '@/app/components/common/animation/AnimatedListingWithSubView.vue';
import { agentTableFieldsFull, agentTableFieldsMinimal } from '@/app/components/agent/tableFields/agentTableFields';
import AddIndividualModal from '@/app/components/individual/AddIndividualModal.vue';
import { Individual, IndividualType } from 'ah-api-gateways';
import IndividualInfo from '@/app/components/individual/IndividualInfo.vue';
import InfoTooltip from '@/app/components/common/InfoTooltip.vue';
import IndividualListing from '@/app/components/individual/IndividualListing.vue';
import {
  companyMemberTableFieldsFull,
  companyMemberTableFieldsMinimal,
} from '@/app/components/individual/tableFields/companyMemberTableFields';
import { useAuthStore } from '@/app/store/authStore';
import { computed, ref } from 'vue';
import { useMediaQuery } from 'ah-common-lib/src/mediaQuery';
import { useRouter } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'MembersSettingsView',
  props: {
  memberId: {
    type: String,
    required: false,
  },
},
  setup(__props) {

const props = __props;



const router = useRouter();

const mediaQuery = useMediaQuery();

const individualListing = ref<IndividualListing>();

// Auto-set by AnimatedListingWithSubView[animatedState.sync] in template
const animatedState = ref<AnimatedListingWithSubViewState>();

const authStore = useAuthStore();

const individualsFilter = computed(() => {
  if (authStore.isAgent) {
    return {
      type: [IndividualType.PARTNER_ADMIN, IndividualType.PARTNER_AGENT],
    };
  } else {
    return {
      type: [IndividualType.CLIENT_ADMIN, IndividualType.CLIENT_INDIVIDUAL],
    };
  }
});

const memberTableConfig = computed(() => {
  if (authStore.isAgent) {
    return mediaQuery.is('mdDown') && !animatedState.value?.wideList
      ? { tableFields: agentTableFieldsMinimal }
      : { tableFields: agentTableFieldsFull };
  } else {
    return mediaQuery.is('mdDown') && !animatedState.value?.wideList
      ? { tableFields: companyMemberTableFieldsMinimal }
      : { tableFields: companyMemberTableFieldsFull };
  }
});

function onIndividualUpdated() {
  individualListing.value?.loadData();
}

function onIndividualDeleted() {
  gotoMember();
  if (individualListing.value) {
    individualListing.value.loadData();
  }
}

function gotoMember(agent?: Individual) {
  if (!agent || props.memberId === agent.id) {
    router.push({ path: '..', append: true });
  } else {
    if (props.memberId) {
      router.push({ path: `../${agent.id}`, append: true });
    } else {
      router.push({ path: agent.id, append: true });
    }
  }
}

return { __sfc: true,props, router, mediaQuery, individualListing, animatedState, authStore, individualsFilter, memberTableConfig, onIndividualUpdated, onIndividualDeleted, gotoMember, AddIndividualModal, IndividualInfo, InfoTooltip, IndividualListing }
}

})